/** Chrome shared by the pause and debrief overlays: the dimmer, the dialog box, the buttons. */

import './overlay.css';
import { el } from './dom';

/** The only HUD elements that take pointer input. */
export function button(label: string, onClick: () => void): HTMLButtonElement {
  const node = el('button', 'hud-btn', label);
  node.type = 'button';
  node.addEventListener('click', onClick);
  return node;
}

/** A full-image dimmer holding one dialog box; starts hidden. */
export function buildOverlay(kindClass: string, label: string): { overlay: HTMLElement; dialog: HTMLElement } {
  const overlay = el('div', `hud-overlay ${kindClass} hud-hidden`);
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-label', label);
  const dialog = el('div', 'hud-dialog');
  overlay.append(dialog);
  return { overlay, dialog };
}

export function actionsRow(...buttons: HTMLButtonElement[]): HTMLElement {
  const row = el('div', 'hud-dialog-actions');
  row.append(...buttons);
  return row;
}
